/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-roles.reducer';

export const UserRolesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userRolesEntity = useAppSelector(state => state.userRoles.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userRolesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userRoles.detail.title">UserRoles</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userRoles.id">Id</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.id}</dd>
          <dt>
            <span id="role">
              <Translate contentKey="tinyMedicRestApp.userRoles.role">Role</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.role}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.userRoles.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userRoles.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.userRoles.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userRoles.active">Active</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userRoles.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userRolesEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userRoles.user">User</Translate>
          </dt>
          <dd>{userRolesEntity.user ? userRolesEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userRoles.tenant">Tenant</Translate>
          </dt>
          <dd>{userRolesEntity.tenant ? userRolesEntity.tenant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userRoles.subTenant">Sub Tenant</Translate>
          </dt>
          <dd>{userRolesEntity.subTenant ? userRolesEntity.subTenant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userRoles.employee">Employee</Translate>
          </dt>
          <dd>{userRolesEntity.employee ? userRolesEntity.employee.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-roles" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-roles/${userRolesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserRolesDetail;
